export function anchorHelper() {
    let externalAnchors = document.querySelectorAll('a[target="_blank"]') as NodeListOf<HTMLAnchorElement>;
    let base = window.location.hostname;

    for (let i = 0; i < externalAnchors.length; i++) {
        let url = new URL(externalAnchors[i].href);

        if (url.hostname.includes(base)) {
            externalAnchors[i].relList.remove("noopener", "noreferrer");
        } else {
            externalAnchors[i].relList.add("noopener", "noreferrer");
        }
    }
}
